import React, { Suspense, lazy } from 'react'
import { Route, Routes, BrowserRouter, } from 'react-router-dom'
import ConfigProvider from '../../providers/Config/Provider'
import { MsalProvider, } from '@azure/msal-react';

const Layout = lazy(() => import('../../containers/Layout/Layout'))

const App = ({ config: appConfig, instance }) => {
  const config = { ...appConfig }
  const { pages, components, containers } = config
  const { LandingPage = false } = pages || {}
  const { Loading = () => <div /> } = components || {}
  const { AppContainer = React.Fragment } = containers || {}

  return (
    <MsalProvider instance={instance}>
    <Suspense fallback={<Loading />}>
      <ConfigProvider appConfig={config}>
        <AppContainer>
          {/* <HashRouter> */}
          <BrowserRouter>
            <Routes>
              {LandingPage && (
                <Route path="/" exact element={<LandingPage />} />
              )}
              <Route
                path="*"
                element={
                  <Suspense fallback={<Loading />}>
                    <Layout appConfig={config} />
                  </Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
          {/* </HashRouter> */}
        </AppContainer>
      </ConfigProvider>
    </Suspense>
    </MsalProvider>
  )
}

export default App
